import axios from "axios";
import { Environment } from '../../src/environments/Environment';
import { eventKeys, verticalUserGroupMapping } from "../common/constants";
import { EventEmitter } from "../common/events";
import { getAuthState } from "../common/auth.state";

const baseUrl = Environment.baseUrl;

export function getVertical() {
  return axios.get(baseUrl + "/vertical");
}

export function getAllVerticals() {
  return axios.get(baseUrl + "/vertical/all");
}

export function getAllVerticalsComplete() {
  return axios.get(baseUrl + "/vertical/allverticals");
}

export function getSelectedVertical(verticalId) {
  return axios.get(baseUrl + "/vertical/" + verticalId);
}

export async function getDefaultVerticalName() {
  let verticalId = getDefaultVertical();
  if (verticalId && verticalId > 0) {
    let result = await getSelectedVertical(verticalId);
    return result.data?.verticalName;
  }
  else {
    return "";
  }
}

export function getDefaultVertical() {
  let defaultVertical = parseInt(window.DefaultVertical ?? 0);
  return defaultVertical;
}

export async function setDefaultVertical() {
  const { roles } = getAuthState();
  let userGroups = roles;
  if (userGroups?.length) {
    for (var i = 0; i < userGroups.length; i++) {
      let userGroup = userGroups[i];
      let verticalUserGroupIndex = verticalUserGroupMapping.findIndex(t => t.UserGroup === userGroup);
      if (verticalUserGroupIndex > -1) {
        updateDefaultVerticalObject(verticalUserGroupMapping[verticalUserGroupIndex].Vertical);
        break;
      }
    }
  }
}

export function setDefaultSelectedVertical(verticalId) {
  updateDefaultVerticalObject(parseInt(verticalId ?? 0));
}

function updateDefaultVerticalObject(defaultVertical) {
  window.DefaultVertical = defaultVertical;
  EventEmitter.dispatch(eventKeys.VerticalNameUpdate, defaultVertical);
}